const move = (arr, oldIndex, newIndex, checkDisabled) => {
  // [ { v: 1 }, { v: 2 }, { v: 3, d: true }, { v: 4, d: true }, { v: 5 }, { v: 6, d: true }, { v: 7 }, { v: 8 } ]
  // 1 -> 6
  // [ { v: 1 }, { v: 5 }, { v: 3, d: true }, { v: 4, d: true }, { v: 7 }, { v: 6, d: true }, { v: 2 }, { v: 8 } ]

  const delta = newIndex > oldIndex ? 1 : -1
  const lowIndex = delta > 0 ? oldIndex : newIndex
  const highIndex = delta > 0 ? newIndex : oldIndex
  const movableItem = arr[oldIndex]

  arr[oldIndex] = undefined

  let i = delta > 0 ? lowIndex : highIndex
  while (delta > 0 ? i < highIndex : i > lowIndex) {
    if (arr[i] === undefined) {
      let k = i + delta
      while (arr[k] && checkDisabled(arr[k])) k += delta
      arr[i] = arr[k]
      arr[k] = undefined
    }
    i += delta
  }

  arr[newIndex] = movableItem

  return arr
}

const findLastActiveIndex = (arr, checkDisabled) => {
  let lastIndex = -1

  arr.forEach((item, index) => {
    if (!checkDisabled(item)) {
      lastIndex = index
    }
  })

  return lastIndex
}

const remove = (arr, index, checkDisabled) => {
  const lastActiveIndex = findLastActiveIndex(arr, checkDisabled)

  if (lastActiveIndex > 0 && lastActiveIndex !== index) {
    arr = move(arr, index, lastActiveIndex, checkDisabled)
  }

  return arr
}


export default {
  move,
  remove,
}
